
import { defineComponent, computed, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import FormComponent from "@/components/form/FormComponent.vue";
export default defineComponent({
  name: "Form",
  props: {
    routeKey: String,
  },
  components: {
    FormComponent,
  },
  setup(props) {
    const store = useStore();

    const isModalOpen = computed(() => {
      return store.getters.getIsModalOpen;
    });
    const modalRoute = computed(() => {
      return store.getters.getModalRoute;
    });
    const parentID = computed(() => {
      return store.getters.getParentID;
    });
    const getRouteKey = computed(() => {
      return props.routeKey;
    });
    const getDynamicList = computed(() => {
      return store.getters.getDynamicList;
    });
    const getMultipleFormEdit = computed(() => {
      return store.getters.getMultipleFormEdit({ key: props.routeKey });
    });
    const getFormName = computed(() => {
      return store.getters.getFormName({ key: props.routeKey });
    });
    const getPaginationTotalItems = computed(() => {
      return store.getters.getPaginationTotalItems({ key: props.routeKey });
    });
    return {
      isModalOpen,
      modalRoute,
      getDynamicList,
      parentID,
      getRouteKey,
      getMultipleFormEdit,
      getFormName,
      getPaginationTotalItems,
    };
  },
});
